import React from 'react';
import PropTypes from 'prop-types';
import { H3, Paragraph } from 'components/core/Typography';
import { Section, Group } from 'components/core/Page';
import { Card } from 'components/core/Card';
import { Image } from 'components/core/Image';
import { Button } from 'components/core/Button';

import carImage1 from 'assets/images/landing/moving-trucks/bellhops-truck-scaled.jpg';
import carImage2 from 'assets/images/landing/moving-trucks/penske-truck.jpg';

import './truckPromoCards.scss';

export function TruckPromoCards({
	isBellhopsMarket,
	bellhopsURL,
	penskeURL,
	location,
}) {
	const { city, state } = location;
	return (
		<Section className="promo-cards">
			<div className="section-content promo-cards-group">
				{!!isBellhopsMarket && (
					<div className="promo-cards-wrapper">
						<H3 size="small">Local moves</H3>
						<Card className="promo-card">
							<Image
								className="promo-cards-image"
								src={carImage1}
								alt={`Bellhops moving truck available for rental in ${city}, ${state}`}
								width={500}
								height={334}
							/>
							<div className="promo-cards-body">
								<Group>
									<H3 size="small">Bellhops</H3>
									<Paragraph>
										Get a 5% discount on a moving truck and
										movers with Bellhops when you book
										through SpareFoot.
									</Paragraph>
								</Group>
								<Button
									fullWidth
									className="promo-cards-cta"
									primary
									href={bellhopsURL}
									rel="nofollow"
								>
									Shop now
								</Button>
							</div>
						</Card>
					</div>
				)}
				<div className="promo-cards-wrapper">
					<H3 size="small">Local &amp; long distance moves</H3>
					<Card className="promo-card">
						<Image
							className="promo-cards-image"
							src={carImage2}
							alt={`Penske moving truck available for rental in ${city}, ${state}`}
							width={500}
							height={334}
						/>
						<div className="promo-cards-body">
							<Group>
								<H3 size="small">Penske</H3>
								<Paragraph>
									SpareFoot customers receive additional
									savings when renting with Penske.
									<br />
									<br />
								</Paragraph>
							</Group>
							<Button
								fullWidth
								className="promo-cards-cta"
								primary
								href={penskeURL}
								rel="nofollow"
							>
								Shop now
							</Button>
						</div>
					</Card>
				</div>
			</div>
		</Section>
	);
}

TruckPromoCards.propTypes = {
	bellhopsURL: PropTypes.string,
	penskeURL: PropTypes.string,
	isBellhopsMarket: PropTypes.bool,
	location: PropTypes.object,
};

export default TruckPromoCards;
